import PostPageView from "../../components/community/post_pageview";

const AdminArticlesScreen = () => {
    return <PostPageView isAdmin={true} isPost={false} />
}

export default AdminArticlesScreen;